import axios from 'axios'
import forEach from 'lodash/forEach'
import get from 'lodash/get'
import map from 'lodash/map'
import 'url-search-params-polyfill'

import apiConfiguration from '../utilities/api/apiConfiguration'

export const FETCH_HOTEL_CONTENT_FEEDS_BEGIN   = 'FETCH_HOTEL_CONTENT_FEEDS_BEGIN'
export const FETCH_HOTEL_CONTENT_FEEDS_SUCCESS = 'FETCH_HOTEL_CONTENT_FEEDS_SUCCESS'
export const FETCH_HOTEL_CONTENT_FEEDS_FAILURE = 'FETCH_HOTEL_CONTENT_FEEDS_FAILURE'

export const fetchHotelContentFeedsBegin = () => ({
	type: FETCH_HOTEL_CONTENT_FEEDS_BEGIN,
})

export const fetchHotelContentFeedsSuccess = hotelInfo => ({
	type: FETCH_HOTEL_CONTENT_FEEDS_SUCCESS,
	payload: hotelInfo
})

export const fetchHotelContentFeedsError = error => ({
	type: FETCH_HOTEL_CONTENT_FEEDS_FAILURE,
	payload: { error }
})

// Handle Availability Fetch & Functionality
export default function fetchHotelContentFeeds() {
	return (dispatch) => {
		// Client ID key used by IPS to pull correct brand data
		let clientId = null
		if (
			process.env.REACT_APP_FLOW_CLIENT_ID &&
			process.env.REACT_APP_FLOW_CLIENT_ID !== 'null'
		) {
			clientId = process.env.REACT_APP_FLOW_CLIENT_ID
		}

		const fetchHotelContentFeedsQuery = new URLSearchParams({ clientId })

		const apiFeedsPath = process.env.REACT_APP_FLOW_ENDPOINT_URL
      + '/api/content/feeds?'
      + fetchHotelContentFeedsQuery.toString()

		dispatch(fetchHotelContentFeedsBegin())
		return axios.get(apiFeedsPath, apiConfiguration())
			.then((response) => {
        const feeds = get(response, 'data.hydra:member', [])
        return Promise.allSettled(
          map(feeds, id => {
            const fetchContentFeedQuery = new URLSearchParams({ clientId })
            const apiFeedPath = process.env.REACT_APP_FLOW_ENDPOINT_URL
							+ `/api/content/feeds/${id}?`
							+ fetchContentFeedQuery.toString()
            return axios.get(apiFeedPath, apiConfiguration())
          })
        )
          .then(results => {
            const feedsContent = {}
            forEach(results, result => {
              if (get(result, 'status') === 'fulfilled') {
                const data = get(result, 'value.data')
                feedsContent[get(data, 'id')] = get(data, 'data')
              }
            })
            dispatch(fetchHotelContentFeedsSuccess(feedsContent))
          })
			})
			.catch(error => {
				dispatch(fetchHotelContentFeedsError(error))
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/fetchHotelContentFeeds.js